import LegalPage from '../components/LegalPage';
import legal from '../legal/legal.json';

// Stamped onto each registration's consent record (AuthPage). Bump when the
// Terms/Privacy content in legal/legal.json materially changes.
export const POLICY_VERSION = '2026-07-08';

export default function TermsPage() {
  return <LegalPage doc={legal.terms} />;
}
